<template>
  <div class="gift-box">
    <van-image class="banner" :src="require('@/assets/images/subject_gift_banner.png')" show-error show-loading />
    <div class="rule-box">
      <div class="rule">
        <div class="title">规则说明</div>
        <div class="content">
          <div class="line"><span class="point" /><p>只有购买过赠送类课程，才能赠送给朋友。</p></div>
          <div class="line"><span class="point" /><p>被赠送好友必须是未购买过课程的朋友。</p></div>
          <div class="line"><span class="point" /><p>不是所有课程都可赠送，仅部分带赠送属性的课程可赠送。</p></div>
        </div>
      </div>
    </div>
    <div class="subjects">
      <div class="box">
        <van-tabs v-model="currentTab" @change="switchCoupons" animated swipeable sticky>
          <van-tab :title="item.name" v-for="(item, index) in tabs" :key="index">
            <template v-if="currentTab===0">
              <div class="send_subject" v-for="(userSubject, index) in userSubjects" :key="index" @click="loadPage('giftDetail', { id: userSubject.subject.id })">
                <img class="logo" :src="userSubject.subject.smallLogoImg" />
                <div class="content">
                  <div class="title">{{ userSubject.subject.title }}</div>
                  <div class="desc">{{ userSubject.subject.desc }}</div>
                  <!-- <div class="people_want">{{ random(10, 1000) }}人想要</div> -->
                  <div class="bottom">
                    <div class="price"><span class="tag">¥</span> {{ userSubject.subject.fullPrice }}</div>
                    <div class="button_send">赠好友</div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="send_log" v-for="(subjectSendLog, index) in subjectSendLogs" :key="index">
                <div class="accept_user">
                  <van-image class="avatar" :src="subjectSendLog.acceptUser.avatar" round />
                  <div class="name">{{ subjectSendLog.acceptUser.nickname }}</div>
                  <div class="tip">领取了您的课程</div>
                </div>
                <div class="bottom">
                  <van-image class="logo" :src="subjectSendLog.subject.smallLogoImg" radius="10px" />
                  <div class="content">
                    <div class="title">{{ subjectSendLog.subject.title }}</div>
                    <div class="price"><span class="tag">¥</span> {{ subjectSendLog.subject.fullPrice }}</div>
                    <div class="time">领取时间: {{ $moment(subjectSendLog.createdAt).format('YYYY-MM-DD HH:mm') }}</div>
                  </div>
                </div>
              </div>
            </template>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="copyright">明明城堡拥有活动最终解释权</div>
  </div>
</template>
<script>
import { getUserSubjects, getSendSubjectsLog } from './query.gql'
export default {
  name: 'GiftList',
  data() {
    return {
      currentTab: 0,
      userSubjects: [], // 可赠送课程
      subjectSendLogs: [], // 已赠送课程
      tabs: [{
        type: 'unsend',
        name: '可赠送'
      }, {
        type: 'send',
        name: '已赠送'
      }]
    }
  },
  async mounted() {
    await this.weixinAuth()
    this.loadData()
  },
  methods: {
    random(min, max) {
      return Math.round(Math.random() * (max - min)) + min
    },
    loadData() {
      // 请求数据
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      if (self.currentTab === 0) {
        self.$apollo.query({
          query: getUserSubjects,
          fetchPolicy: 'no-cache'
        }).then(res => {
          self.userSubjects = res.data.userSubjects
          self.$toast.clear()
        }).catch(err => {
          console.error('page：gift/index。请求getUserSubjects报错', err)
          self.$toast.clear()
          self.$toast.fail('加载数据出错')
        })
      } else {
        self.$apollo.query({
          query: getSendSubjectsLog,
          fetchPolicy: 'no-cache'
        }).then(res => {
          self.subjectSendLogs = res.data.profile.subjectSendLogs.nodes
          self.$toast.clear()
        }).catch(err => {
          console.error('page：gift/index。请求getSendSubjectsLog报错', err)
          self.$toast.clear()
          self.$toast.fail('加载数据出错')
        })
      }
    },
    switchCoupons(index) {
      this.loadData()
    }
  }
}
</script>
<style lang="scss">
.gift-box {
  background-color: #FC503F;

  .banner {
    width: 100%;
  }

  .rule-box {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: -50px;

    .rule {
      width: 90%;
      min-height: 240px;
      background: url('~@/assets/images/subject_gift_rule_bg.png') no-repeat center center;
      background-size: contain;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .title {
        width: 100%;
        text-align: center;
        font-size: 18px;
        font-weight: 600;
        color: #FD5E4A;
      }

      .content {
        width: 85%;
        margin-top: 4px;

        .line {
          display: flex;
          position: relative;

          .point {
            width: 8px;
            height: 8px;
            background: #FD5E4A;
            border-radius: 4px;
            margin-right: 8px;
            position: relative;
            top: 12px;
          }

          p {
            width: calc(100% - 10px);
            margin-top: 6px;
            color: #333333;
            font-size: 14px;
            font-weight: 400;
            position: relative;
          }
        }
      }
    }
  }

  .subjects {
    width: 100%;
    display: flex;
    justify-content: center;

    .box {
      width: 82%;
      min-height: 240px;
      background-color: #FFFFFF;
      border: 8px solid #FDD9A1;
      border-radius: 8px;

      .send_subject{
        width: calc(100% - 32px);
        height: 110px;
        margin: 16px;
        box-shadow: 0px 0px 10px #DDDDDD;
        border-radius: 10px;
        display: flex;

        .logo {
          width: 110px;
          height: 110px;
          min-width: 110px;
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
        }

        .content {
          position: relative;
          width: calc(100% - 120px);
          padding: 4px;
          padding-left: 6px;

          .title {
            color: black;
            font-size: 14px;
            font-weight: 600;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .desc {
            color: #9b9b9b;
            margin-top: 2px;
            font-size: 14px;
            overflow-wrap: break-word;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            /* autoprefixer: off */
            -webkit-box-orient: vertical;
          }

          .people_want {
            margin-top: 4px;
            font-size: 12px;
            color: #9b9b9b;
          }

          .bottom {
            position: absolute;
            bottom: 4px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .price {
              text-align: center;
              color: #FF3D00;
              font-size: 18px;
              font-weight: 600;

              .tag {
                font-size: 14px;
              }
            }

            .button_send {
              margin-right: 12px;
              padding: 3px 10px 3px 10px;
              border-radius: 12px;
              height: 19px;
              line-height: 19px;
              font-size: 12px;
              font-weight: 600;
              text-align: center;
              background: #FD5E4A;
              color: #FFFFFF;
            }
          }
        }
      }

      .send_log {
        width: calc(100% - 64px);
        margin: 16px;
        padding: 16px;
        box-shadow: 0px 0px 10px #DDDDDD;
        border-radius: 10px;

        .accept_user {
          display: flex;
          align-items: center;

          .avatar {
            width: 20px;
            height: 20px;
          }

          .name {
            margin-left: 8px;
            font-size: 14px;
            font-weight: 600;
          }

          .tip {
            margin-left: 16px;
            color: #9b9b9b;
            font-size: 12px;
          }
        }

        .bottom {
          width: 100%;
          margin-top: 16px;
          display: flex;

          .logo {
            width: 80px;
            height: 80px;
          }

          .content {
            width: calc(100% - 85px);
            margin-left: 8px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .title {
              width: 100%;
              color: black;
              font-size: 14px;
              font-weight: 600;
              text-align: left;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            .price {
              color: #FF3D00;
              font-size: 16px;
              font-weight: 400;
              text-align: left;

              .tag {
                font-size: 14px;
              }
            }

            .time {
              font-size: 12px;
              font-weight: 400;
              color: #9b9b9b;
              text-align: left;
            }
          }
        }
      }
    }
  }

  .copyright {
    padding: 20px 0px 20px 0px;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: #FFFFFF;
  }
}
</style>
